export default "import * as Cesium from 'cesium'\r\n\r\nconst viewer = new Cesium.Viewer('cesiumContainer')\r\n"